import {
  getAllVendors,
  createVendor,
  updateVendor,
  updateVendorApproval,
} from "services/vendorServices";
import {
  getVendorsStart,
  getVendorsSuccess,
  getVendorsFailure,
  createVendorStart,
  createVendorSuccess,
  createVendorFailure,
  updateVendorStart,
  updateVendorSuccess,
  updateVendorFailure,
  updateVendorApprovalStart,
  updateVendorApprovalSuccess,
  updateVendorApprovalFailure,
} from "store/features/vendor/vendorSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

export const fetchVendors = () => async (dispatch) => {
  try {
    dispatch(getVendorsStart());
    const response = await getAllVendors();
    dispatch(getVendorsSuccess(response.data));
  } catch (error) {
    dispatch(getVendorsFailure(error.message));
  }
};

export const registerVendor = (vendorData) => async (dispatch) => {
  try {
    dispatch(createVendorStart());
    const response = await createVendor(vendorData);
    dispatch(createVendorSuccess(response.data));
  } catch (error) {
    dispatch(createVendorFailure(error.message));
  }
};

export const updateVendorAction =
  (vendorId, updateData) => async (dispatch) => {
    try {
      dispatch(updateVendorStart());
      const response = await updateVendor(vendorId, updateData);
      dispatch(updateVendorSuccess(response.data));
    } catch (error) {
      dispatch(updateVendorFailure(error.message));
    }
  };

export const updateVendorApprovalAction =
  (vendorId, isApproved) => async (dispatch) => {
    try {
      dispatch(updateVendorApprovalStart());
      const response = await updateVendorApproval(vendorId, isApproved);
      dispatch(updateVendorApprovalSuccess(response.data));
      const message = isApproved
        ? "Vendor approved successfully"
        : "Vendor approval revoked";
      showSuccessToast(message);
    } catch (error) {
      dispatch(updateVendorApprovalFailure(error.message));
      showErrorToast(error.message || "Failed to update vendor approval");
    }
  };
